"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require('./components/dragula.class'));
__export(require('./components/dragula.directive'));
__export(require('./components/dragula.provider'));
__export(require('./components/dragular.module'));



//////////////////
// WEBPACK FOOTER
// /app/~/ng2-dragula/index.js
// module id = ../../../../ng2-dragula/index.js
// module chunks = 16